/* ee-infinite.js — Eyewear Essentials
   Replaces numbered pagination with a Load more button that also auto-loads
   as the visitor approaches it.

   Progressive enhancement: the markup is a real <a href> to the next page, so
   with JS off (and for crawlers) the pages remain reachable in a chain.
   If a fetch fails we stop auto-loading and leave the button clickable, so a
   flaky connection never turns into an endless retry loop. */
(function () {
  'use strict';

  function init() {
    var wrap = document.querySelector('[data-ee-more]');
    if (!wrap || wrap.dataset.eeReady) return;
    wrap.dataset.eeReady = '1';

    var selector = wrap.getAttribute('data-ee-grid') || '.ee-product-grid';
    var grid = document.querySelector(selector);
    var link = wrap.querySelector('[data-ee-more-link]');
    var status = wrap.querySelector('[data-ee-more-status]');
    if (!grid || !link) return;

    var busy = false;
    var failures = 0;
    var io = null;

    function say(msg) { if (status) status.textContent = msg || ''; }

    function stopObserving() { if (io) { io.disconnect(); io = null; } }

    function finish() {
      stopObserving();
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
    }

    function onSee(entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { load(); return; }
      }
    }

    function observe() {
      if (!('IntersectionObserver' in window) || io) return;
      io = new IntersectionObserver(onSee, { rootMargin: '600px 0px' });
      io.observe(wrap);
    }

    function load() {
      if (busy) return;
      var url = link.getAttribute('href');
      if (!url) return;

      busy = true;
      wrap.classList.add('is-loading');
      say('Loading more…');

      fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector(selector);
          var added = 0;

          if (incoming) {
            var frag = document.createDocumentFragment();
            while (incoming.firstElementChild) {
              frag.appendChild(incoming.firstElementChild);
              added++;
            }
            grid.appendChild(frag);
          }

          /* Scroll-reveal elements start at opacity 0 and are only revealed by
             an observer that already ran, so show any that just arrived. */
          var hidden = grid.querySelectorAll('[data-ee-reveal]:not(.is-in)');
          for (var i = 0; i < hidden.length; i++) hidden[i].classList.add('is-in');

          /* ee-swipe.js listens for this and wires up the colour carousel on
             the new cards. It guards against double-init, so this is safe. */
          grid.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));

          var nextLink = doc.querySelector('[data-ee-more-link]');
          busy = false;
          failures = 0;
          wrap.classList.remove('is-loading');
          say('');

          if (nextLink && added) {
            link.setAttribute('href', nextLink.getAttribute('href'));
          } else {
            finish();
          }
        })
        .catch(function () {
          busy = false;
          failures++;
          wrap.classList.remove('is-loading');
          stopObserving();
          say(failures > 2 ? 'Still not loading. Please refresh the page.' : 'Could not load more — tap to try again.');
        });
    }

    link.addEventListener('click', function (event) {
      event.preventDefault();
      observe();
      load();
    });

    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
